// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FXZT","badges":"styles_badges__2mZHG"};